import React, { useContext } from 'react';
import context from 'app/contexts/CMSContext';

const CMSContent = ({ contentKey }) => {
  const { [contentKey]: content } = useContext(context);

  return <div dangerouslySetInnerHTML={{ __html: content }} />;
};

export default CMSContent;
